import EcIps from './ec-ips'
export default {
  EcIps
}



// WEBPACK FOOTER //
// ./src/components/index.js